export default "__VITE_ASSET__CUcQo1ws__"